import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA } from '@angular/material/dialog';
import { IUserEvents } from 'src/app/models/user-events';

@Component({
  selector: 'app-user-event-dialog',
  templateUrl: './user-event-dialog.component.html',
  styleUrls: ['./user-event-dialog.component.scss'],
})
export class UserEventDialogComponent {
  constructor(@Inject(MAT_DIALOG_DATA) public data: IUserEvents) {}
}
